export class RepairsUpdatesLogsDeleteRequest {
  logId!: string

  constructor(logId: string) {
    this.logId = logId
  }
}
